import CanopyGoal from './canopyGoal'

export default CanopyGoal